<template>
  <vue-dialog :dialog-data="dialogData" @confirm="confirm">
    <el-form :model="dialogForm" class="label-gray" label-width="100px" :rules="rules" ref="dialogForm">
      <el-form-item label="赠送门店">
        <el-input :value="dialogData.row.name"></el-input>
      </el-form-item>
      <el-form-item label="赠送数量" prop="quantity">
        <el-input-number v-model="dialogForm.quantity" :min="0" :step="1"></el-input-number>
        <span class="suffix">个</span>
      </el-form-item>
      <el-form-item label="赠送天数" prop="day">
        <el-input-number v-model="dialogForm.day" :min="0" :step="1"></el-input-number>
        <span class="suffix">天</span>
      </el-form-item>
      <el-form-item label="收款金额" prop="amount">
        <el-input-number v-model="dialogForm.amount" :min="0" :step="0.01"></el-input-number>
        <span class="suffix">元</span>
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model.trim="dialogForm.remark"></el-input>
      </el-form-item>
    </el-form>
  </vue-dialog>
</template>

<script>
  import {inputEmpty} from '@utils/validate'
  export default {
    name: "GiveAuth",
    props: {dialogData: Object},
    data() {
      return {
        dialogForm: {
          shop_id: this.dialogData.row.id,
          quantity: 100,
          day: 365,
          amount: 0,
          remark: "",
        },
        rules: {
          quantity: [inputEmpty("赠送数量", ["blur", "change"])],
          day: [inputEmpty("赠送数量", ["blur", "change"])],
          amount: [inputEmpty("赠送数量", ["blur", "change"])],
        },
      }
    },
    methods: {
      confirm() {
        this.$refs["dialogForm"].validate(async isOk => {
          if (isOk) {
            this.openConfirm(`赠送 ${this.dialogData.row.name} 授权吗`, async () => {
              let nv = {...this.dialogForm};
              nv.amount = this.convertFen(nv.amount);
              let res = await this.$Http.giveAuth(nv);
              if (res) {
                this.msgSuccess("赠送成功");
                this.dialogData.visible = false;
                this.$emit("table-reload");
              }
            });
          }
        });
      },
    },
  }
</script>

<style scoped>

</style>
